import React from 'react'
import { Columns, Option } from '../../../../../../shared/EditableTable/Model'

export default function initialDataEligibleExpenseConfig(options: Option<string>[], financialYears: Option<string>[], prevTotalGrantAmount: number[], preview: boolean) {
  const toNumber = (anything: any) => {
    const tempNumber = Number(anything)
    return Number.isNaN(tempNumber) ? 0 : tempNumber
  }

  const columns: Columns[] = [
    {
      id: 'crmEligibleExpenditureCategoryID',
      label: 'Planned eligible expenditure category',
      accessor: 'crmEligibleExpenditureCategoryID',
      dataType: 'select',
      options,
      Footer: (() => <span className="table-footer-th">Total Eligible Expenditure Per Financial Year</span>),
      Footer2: (() => <span className="table-footer-th">Total Grant Amount Sought Per Financial Year</span>),
      minWidth: 280,
      width: 280,
    },
  ]
  financialYears.forEach((item, index) => {
    columns.push(
      {
        id: `fyExpenditureAmount${index + 1}`,
        label: `${item.label} Planned eligible expenditure amount $AUD`,
        accessor: `fyExpenditureAmount${index + 1}`,
        dataType: 'number',
        Footer: ((info: { rows: number[]; }) => {
          const total = React.useMemo(
            () => info.rows.reduce((sum: number, row: any) => toNumber(index === 0 ? row.values.fyExpenditureAmount1 : row.values.fyExpenditureAmount2) + sum, 0), // index at FY1, else FY2
            [info.rows],
          )
          return <>{total.toFixed(2)}</>
        }),
        Footer2: (() => (
          <input
            id={item.value}
            name={item.label}
            role="cell"
            className="data-input"
            contentEditable="true"
            type="number"
            defaultValue={prevTotalGrantAmount[index]}
            value={preview && prevTotalGrantAmount[index]}
            key={prevTotalGrantAmount[index]}
          />
        )),
      },
    )
  })
  columns.push(
    {
      id: 'remove',
      label: 'Remove',
      accessor: 'remove',
      dataType: 'remove',
      minWidth: 70,
      width: 70,
      Footer: '',
      Footer2: '',
    },
  )

  return {
    columns, skipReset: false,
  }
}
